export function getName(customer: {
  firstName?: string | null
  lastName?: string | null
  [key: string]: any
}) {
  return customer.firstName && customer.lastName
    ? `${customer.firstName} ${customer.lastName}`
    : 'Unbekannt'
}
